export default "__VITE_ASSET__B$D1qtzA__"